import * as React from "react";
import { SVGProps, memo } from "react";
const SvgPublishedConnectionExtractIcon14Px = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      d="M2 2h5v1H6v1h2a.995.995 0 0 0-.134-.5A.995.995 0 0 0 8 3V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1c0 .182.049.353.134.5A.995.995 0 0 0 1 4v1a1 1 0 0 0 1 1h1.126A4.007 4.007 0 0 1 3 5H2V4h1V3H2V2Z"
      fill="#666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9v-.126c.32.082.655.126 1 .126v.466c0 .466.24.84.577 1.054v.566c.425.15.762.487.913.913l.01.028A1.436 1.436 0 0 0 8.49 12L13 12v1H8.49a1.5 1.5 0 0 1-2.788.102l-.04-.101L1 13v-1l4.662-.001-.01.028.01-.028c.15-.426.488-.763.914-.914V9.906A1 1 0 0 1 6 9Zm.576 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
      fill="#666"
    />
    <path
      d="M12 9h-1.238l-1.2 1H12a1 1 0 0 0 1-1V8a.995.995 0 0 0-.134-.5A.995.995 0 0 0 13 7V6a1 1 0 0 0-1-1H9.562l1.2 1H12v1h-.244c.138.318.138.682 0 1H12v1ZM7 5h.116A1.251 1.251 0 0 0 7 5.534V6a1 1 0 0 1-.866-.5A1 1 0 0 1 7 5Z"
      fill="#666"
    />
    <path
      d="M4 4v1a3 3 0 0 0 3 3h1v1.466a.25.25 0 0 0 .41.192l2.36-1.966a.25.25 0 0 0 0-.384L8.41 5.342a.25.25 0 0 0-.41.192V7H7a2 2 0 0 1-2-2V4H4ZM4 3h1v1H4V3Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgPublishedConnectionExtractIcon14Px);
export default Memo;
